import React, { useEffect } from "react";
import { Button, Form, Input, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { initAuth } from "../../store/actions/creators";
import { IInitialState } from "../../store/reducers/models";
import { useNavigate } from "react-router-dom";
import "./styles.scss";
import logo from "../../assets/images/vincenttaxfiling.png";

// If you have helper constants for form layout, you can keep using them.
// For this file we use inline layout to keep the file self-contained.
const Auth: React.FC = () => {
  const state: IInitialState = useSelector((state: any) => state.store);
  const { isAuthenticated, isAuthLoading } = state;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Try to preserve old behavior (local user redirect)
  useEffect(() => {
    const localUserData = localStorage.getItem("userData");
    if (isAuthenticated || localUserData) {
      try {
        const parsed = localUserData ? JSON.parse(localUserData) : null;
        if (parsed?.departmentId === 7 || parsed?.departmentId === 9) {
          navigate("/reports");
        } else {
          navigate("/dashboard");
        }
      } catch {
        navigate("/dashboard");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    //test
  }, [isAuthenticated]);

  const onFinish = (values: any) => {
    dispatch(initAuth(values));
  };

  return (
    <div className="auth-page">
      <div className="auth-left-illustration" />
      <div className="auth-card-wrapper">
        <div className="auth-card">
          <div className="auth-brand">
            <img src={logo} alt="logo" style={{ width: "40%" }} />
          </div>

          <p className="auth-subtitle">
            Sign in to manage filings, leads and support requests.
          </p>

          <Form
            name="authForm"
            layout="vertical"
            onFinish={onFinish}
            className="auth-form"
            initialValues={{ remember: true }}
          >
            <Form.Item
              label="User email"
              name="email"
              rules={[
                { type: "email", message: "Please enter a valid email" },
                { required: true, message: "Please enter your email" },
              ]}
            >
              <Input size="large" placeholder="you@company.com" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please enter your password" },
              ]}
            >
              <Input.Password size="large" placeholder="••••••••" />
            </Form.Item>

            <Form.Item>
              <Button
                htmlType="submit"
                className="btn-gradient"
                size="large"
                block
                loading={isAuthLoading}
              >
                {isAuthLoading ? "Signing in..." : "Sign In"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Auth;
